export default class FormLookupFixed
{
	
}


// WEBPACK FOOTER //
// ./src/components/FormLookupFixed.js